var _path, _path2, _polygon, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricSurge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Electrical Surge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3,7.2c-0.4-0.4-1-0.4-1.3,0l0,0c-0.4,0.4-0.4,1,0,1.3c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3l0,0 C8.7,8.2,8.7,7.6,8.3,7.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2,38c0.6-0.4,0.7-0.7,0.7-1.1c-5.4-7.6-5.4-18,0-25.6c0.3-0.4,0.2-1-0.2-1.3c-0.4-0.3-1-0.2-1.3,0.2 C1.5,14.4,0,19.3,0,24.5c0.1,4.9,1.6,9.6,4.5,13.6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.4,19.8 24.6,20.4 23,24.5 26.9,24.5 24,30 22.8,29.5 24.7,25.9 21.2,25.9 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,17.6V9.7h-2.1v8h-7.7v-8h-2.1v8h-3.4v5.4l5.1,4.6v6.1l8.9-0.1v-6.1l5.1-4.6v-5.4H29.5z M31.5,22l-5,4.7 v5.4h-5.6v-5.4L15.9,22v-2.7h15.7V22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26,0.2C31.7,0.7,37,3.1,41,7.1c4.1,4.1,6.6,9.5,7,15.2c0.4,5.6-2.5,13.7-6.9,18.6c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.1l0.1-0.1c0,0-0.1,0.1-0.1,0.1c-0.7,0.7-2.7,2.3-2.8,2.4c-2.9,2.1-6.2,3.5-9.7,4.1c-0.3,0-0.5,0.1-0.8,0.1 c-1,0-2-0.4-2.8-1c-1-0.8-1.6-2.1-1.6-3.4l0-6.4l-2,0v-1.9h5.7V37L25,37l0,6.4c0,0.7,0.3,1.4,0.8,1.9l0.1,0.1 c0.6,0.5,1.4,0.7,2.1,0.6c3.3-0.6,6.3-1.9,9-3.8c0.3-0.2,1.6-1,2.8-2.4L39.5,40c9.1-10.5,7.9-23.7,0.2-31.5 c-7.5-7.5-19.8-8.5-28.5-2.4c-0.4,0.3-1,0.2-1.3-0.2c-0.3-0.4-0.2-1,0.2-1.3C14.7,1.3,20.3-0.2,26,0.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricSurge);
export default __webpack_public_path__ + "static/media/electric-surge.a6196daebdac005cc838f85300ba1071.svg";
export { ForwardRef as ReactComponent };